import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../environments/environment';
import { Globals, UserProfileDTO } from '../Models/UserProfile.model';
import { AppWideUser, Token } from "../Services/AppUserProfile";
import { Login } from "../Services/login-service";
import { UserService } from '../Services/user.service';


declare var $: any;
declare var swal: any;
@Component({
    moduleId: module.id,
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.css'],
    providers: [CookieService, UserService]
})

export class RegisterComponent implements OnInit {
    hCSType:number;
    designation:number;
    otherDesignation:boolean;
    isCheckedTermsConditions:boolean;
    specifiedDesignation:string;
    public version: string = environment.VERSION;
    message: boolean;
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    confirmPassword: string;
    mobileNumber: string;
    isInvalid: boolean;
    public loading = false;
    designationsList: any;

    constructor(private userService: UserService, private spinnerService: Ng4LoadingSpinnerService, private cookieService: CookieService, private router: Router, private login: Login, private token: Token, private appUserDetails: AppWideUser) {
        this.message = false;
        this.isInvalid = false;

        this.firstName = "";
        this.lastName = "";
        this.email = "";
        this.mobileNumber = "";
        this.password = "";
        this.confirmPassword = "";
        this.designation = -1;
        this.otherDesignation = false;
        this.isCheckedTermsConditions = false;
        this.specifiedDesignation = "";

        this.designationsList = ["Operating Room Nurse","Surgical Technologist","Operating department Personnel","anesthetist","specialist Surgeon","Medical Doctor","Surgical Assistant","Scrub Technician","Medical Student","Nursing student","Other"];      
        
    }

    test: Date = new Date();
    // checkFullPageBackgroundImage() {
    //     var $page = $('.full-page');
    //     var image_src = $page.data('image');

    //     if (image_src !== undefined) {
    //         var image_container = '<div class="full-page-background" style="background-image: url(' + image_src + ') "/>';
    //         $page.append(image_container);
    //     }
    // };
    onLoginSelect() {
        this.router.navigate(["login"]);
    };
    hCSSelected(healthCareSystem){
        this.hCSType = healthCareSystem;
    }
    designationSelected(desgSelected){
        if (desgSelected != 10) {
            this.specifiedDesignation = "";
            this.otherDesignation = false;
        }
        else
        {
            this.otherDesignation = true;
        }

    }
    getAccessToken() {
        if (location.hash) {
            if (location.hash.split('access_token=')) {
                var accessToken = location.hash.split('access_token=')[1].split('&')[0];
                if (accessToken) {
                    this.token.access_token = accessToken;
                    this.cookieService.set('Token', JSON.stringify(this.token));
                    //Globals.LoginUsrId = 2;
                    //==============>
                    this.appUserDetails.UserId = 2; // change 2 to userid .
                    this.cookieService.set('userId', this.appUserDetails.UserId.toString());
                    this.cookieService.set('AppWideUser', JSON.stringify(this.appUserDetails));
                    //<==============
                    this.router.navigate(["layout"]);
                    //this.isUserRegistered(accessToken);
                }
            }
        }
    }

    // isUserRegistered(accessToken) {
    //     this.loading = true;
    //     this.login.isUserRegistered(accessToken).subscribe(x => {
    //         // if (x == 'success') {
    //         if (x != null && x != undefined) {
    //             if (x.HasRegistered) {
    //                 this.cookieService.set('accessToken', accessToken);
    //                 this.cookieService.set('userName', x.Email);
    //                 Globals.LoginUsrId = 1;
    //                 this.router.navigate(["layout"]);
    //             }
    //             else {
    //                 this.signUpExternalUser(accessToken);
    //             }
    //         }
    //         else {
    //             this.signUpExternalUser(accessToken);
    //         }
    //         this.loading = false;
    //     },
    //         error => {
    //             this.loading = false;
    //         })
    // }

    // signUpExternalUser(accessToken) {
    //     this.loading = true;
    //     this.login.signUpExternalUser(accessToken).subscribe(x => {
    //         if (x != null) {
    //             window.location.href = "http://localhost:59671/api/Account/ExternalLogin?provider=Google&response_type=token&client_id=self&redirect_uri=http%3A%2F%2Flocalhost%3A4200%2Fregister&state=2MYiazuo8n5gGdjHQ2sp9KpKchpmPch_DpYr7wnTaHY1";
    //         }

    //         this.loading = false;
    //     },
    //         error => {
    //             this.loading = false;
    //         })
    // };

    SignInWithGoogle() {
       
       //window.location.href = this.token.webAPIURL+"Account/ExternalLogin?provider=Google&response_type=token&client_id=self&redirect_uri=http%3A%2F%2Flocalhost%3A4200%2Fregister&state=2MYiazuo8n5gGdjHQ2sp9KpKchpmPch_DpYr7wnTaHY1";
       window.location.href = "http://localhost:59671/api/Account/ExternalLogin?provider=Google&response_type=token&client_id=self&redirect_uri=http%3A%2F%2Flocalhost%3A4200%2Fregister&state=2MYiazuo8n5gGdjHQ2sp9KpKchpmPch_DpYr7wnTaHY1";

      

        // { 
        //     google login in new window

        //     var windowObjectReference;
        // var acToken;
        // var tokenType;
        // var expiresIn;

        // openRequestedPopup();

        // function openRequestedPopup() {
        //     windowObjectReference = window.open(
        //         "http://localhost:59671/api/Account/ExternalLogin?provider=Google&response_type=token&client_id=self&redirect_uri=http%3A%2F%2Flocalhost%3A4200%2Fregister&state=2MYiazuo8n5gGdjHQ2sp9KpKchpmPch_DpYr7wnTaHY1",
        //         "DescriptiveWindowName",
        //         "resizable,scrollbars,status"
        //     );
        //     var pollTimer = window.setInterval(function () {
        //         try {
        //             //console.log(windowObjectReference.document.URL);
        //             if (location.hash) {
        //                 window.clearInterval(pollTimer);
        //                 var url = windowObjectReference.document.URL;
        //                 windowObjectReference.close();
        //             }

        //         } catch (e) {

        //         }
        //     }, 500);
        // }
        // }

    }

    SignIn(email, password, uid) {
        Globals.LoginUsrId = uid;
        this.router.navigate(["layout"]);
        // this.loading = true;
        // this.login.SignIn(email, password).subscribe(values => {
        //     if (values != null) {
        //         this.isInvalid = false;
        //         this.GenerateToken(values);

        //     }
        //     else {
        //         this.loading = false;
        //         this.isInvalid = true;
        //     }
        // },
        //     error => {
        //         this.isInvalid = true;
        //         this.loading = false;
        //     }); this.loading = true;
        // this.login.SignIn(email, password).subscribe(values => {
        //     if (values != null) {
        //         this.isInvalid = false;
        //         this.GenerateToken(values);

        //     }
        //     else {
        //         this.loading = false;
        //         this.isInvalid = true;
        //     }
        // },
        //     error => {
        //         this.isInvalid = true;
        //         this.loading = false;
        //     });
    };

    showSwal(type) {
        if (type == 'success-message') { 
            swal({
                type: "success",
                title: "Login Successful !",
                text: "Welcome to scrubup!",
                timer: 900,
                showConfirmButton: false
            });
        }
    };


    OnForgotPasswordLink() {
        this.router.navigate(["forgot-password"]);
    };

    GenerateToken(tokenDetail) {
        this.token.access_token = tokenDetail.access_token;
        this.cookieService.set('accessToken', this.token.access_token);
        this.token.userName = tokenDetail.userName;
        this.token.expires = tokenDetail.expires;
        this.token.expires_in = tokenDetail.expires_in;
        this.token.issued = tokenDetail.issued;
        this.token.token_type = tokenDetail.token_type;
        this.cookieService.set('Token', JSON.stringify(this.token));
        this.cookieService.set('access-token', this.token.access_token);
        this.cookieService.set("IsFirstTime", "true");
        this.UserDetails(this.token);
        this.loading = false;
    }

    UserDetails(token: any) {
        this.login.GetUserDetail(token.userName, token).subscribe(x => {
            if (x != null) {
                this.PopulateAndRouteToDashboard(x);
                if (x.AppVersion != this.version) {
                    window.location.reload();
                }
                else {
                    if (this.appUserDetails.UserName.length > 0)
                        this.showSwal('success-message');
                    if (x.IsFirstTimeUser == true) {
                        this.router.navigate(["terms-condition"]);
                    }
                    else {
                        this.router.navigate(["layout"]);
                    }
                }
            }

            else {
                this.isInvalid = true;
            }
        });

    }

    PopulateAndRouteToDashboard(userProfileData) {
        this.appUserDetails.Email = userProfileData.Email;
        this.appUserDetails.Roles = userProfileData.Roles;
        this.appUserDetails.UserName = userProfileData.UserName;
        this.appUserDetails.UserId = userProfileData.UserId;
        this.cookieService.set('userId', this.appUserDetails.UserId.toString());
        this.cookieService.set('AppWideUser', JSON.stringify(this.appUserDetails));
    }


    RegisterUser() {
        if ( this.firstName == "" || this.lastName == "" || this.email == "" || this.password == "" || this.confirmPassword == "" || this.mobileNumber == "" || this.password != this.confirmPassword) {
            this.isInvalid = true;
            return;
        }
        let user: UserProfileDTO;
        user = new UserProfileDTO();
        user.Password = this.password;
        user.ConfirmPassword = this.confirmPassword;
        user.Email = this.email;
        user.UserName = this.email;
        user.FirstName = this.firstName;
        user.LastName = this.lastName;
        user.MobileNumber = this.mobileNumber;
        user.Designation = this.designationsList[this.designation];
        user.SystemType = this.hCSType;
        user.UserId = -1;
        user.Roles = new Array<string>();
        user.Roles.push("User");

        this.userService.CreateUser(user).subscribe(x => {
            if (x == "Success") {
                swal({
                    type: "success",
                    title: "Registration Successful !",
                    text: "Login with your Credentials!",
                    timer: 2000,
                    showConfirmButton: false
                }).catch(swal.noop);
                this.router.navigate(["login"]);
                this.loading = false;
            }
            else if (x == "Exist") {
                // this.showAlreadyExist = true;
                this.loading = false;
            }
            else
                this.loading = false;
        },
            error => {
                this.loading = false;
            });
    }

    ngOnInit() {
        //this.checkFullPageBackgroundImage();
        this.getAccessToken();

        setTimeout(function () {
            // after 1000 ms we add the class animated to the login/register card
            $('.card').removeClass('card-hidden');
        }, 700)
    }
}


// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/register/register.component.ts